import { useEffect, useState } from "react";
import styles from "./Workshop.module.css";
import { TextField, CircularProgress } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ImageIcon from "@mui/icons-material/Image";
import api from "../../services/api";
import loadingImage from "../loading.gif";
import mainStyles from "../Main.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWorkshopDetails } from "../../State/Workshop/Action";

export default function UpdateWorkshop() {
  const [isSaved, setIsSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //States for form fields
  const [name, setName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");

  //Validators state
  const [isValidPhone, setIsValidPhone] = useState(true);
  const [hasError, setHasError] = useState(false);

  const [image1, setImage1] = useState();
  const [image2, setImage2] = useState();
  const [image3, setImage3] = useState();
  const [image4, setImage4] = useState();
  const [image5, setImage5] = useState();

  const [image1Url, setImage1Url] = useState();
  const [image2Url, setImage2Url] = useState();
  const [image3Url, setImage3Url] = useState();
  const [image4Url, setImage4Url] = useState();
  const [image5Url, setImage5Url] = useState();

  const [image1Uploaded, setImage1Uploaded] = useState(false);
  const [image2Uploaded, setImage2Uploaded] = useState(false);
  const [image3Uploaded, setImage3Uploaded] = useState(false);
  const [image4Uploaded, setImage4Uploaded] = useState(false);
  const [image5Uploaded, setImage5Uploaded] = useState(false);

  const [image1UploadFail, setImage1UploadFail] = useState(false);
  const [image2UploadFail, setImage2UploadFail] = useState(false);
  const [image3UploadFail, setImage3UploadFail] = useState(false);
  const [image4UploadFail, setImage4UploadFail] = useState(false);
  const [image5UploadFail, setImage5UploadFail] = useState(false);

  const [image1Loading, setImage1Loading] = useState(false);
  const [image2Loading, setImage2Loading] = useState(false);
  const [image3Loading, setImage3Loading] = useState(false);
  const [image4Loading, setImage4Loading] = useState(false);
  const [image5Loading, setImage5Loading] = useState(false);

  const location = useLocation();
  const workshopId = new URLSearchParams(location.search).get("workshopId");
  const workshop = useSelector((store) => store.workshopResponse.workshop);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getWorkshopDetails(workshopId));
    // api.get("/workshops/" + workshopId).then((res) => {
    //   setWorkshop(res.data);
    //   updateSetters(res.data);
    // });
  }, [workshopId]);

  useEffect(() => {
    if (workshop?.workshopId) {
      updateSetters(workshop);
    }
  }, [workshop]);

  const updateSetters = (workshop) => {
    setName(workshop.name);
    setOwnerName(workshop.ownerName);
    setPhoneNumber(workshop.phoneNumber);
    setAddress(workshop.address);
    setImage1Url(workshop.image1Url);
    setImage2Url(workshop.image2Url);
    setImage3Url(workshop.image3Url);
    setImage4Url(workshop.image4Url);
    setImage5Url(workshop.image5Url);
  };

  const handleImage1 = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", image1);
    formData.append("imageNumber", "IMAGE1");
    let saved = saveImage(formData);
    if (saved) setImage1Uploaded(true);
    else setImage1UploadFail(true);
  };

  const handleImage2 = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", image2);
    formData.append("imageNumber", "IMAGE2");
    let saved = saveImage(formData);
    if (saved) setImage2Uploaded(true);
    else setImage2UploadFail(true);
  };

  const handleImage3 = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", image3);
    formData.append("imageNumber", "IMAGE3");
    let saved = saveImage(formData);
    if (saved) setImage3Uploaded(true);
    else setImage3UploadFail(true);
  };

  const handleImage4 = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", image4);
    formData.append("imageNumber", "IMAGE4");
    let saved = saveImage(formData);
    if (saved) setImage4Uploaded(true);
    else setImage4UploadFail(true);
  };

  const handleImage5 = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", image5);
    formData.append("imageNumber", "IMAGE5");
    let saved = saveImage(formData);
    if (saved) setImage5Uploaded(true);
    else setImage5UploadFail(true);
  };

  const saveImage = (params) => {
    if (workshopId) {
      params.append("workshopId", workshopId);
    } else {
      params.append("workshopId", "");
    }

    var saved = true;

    api
      .post("/workshops/images", params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        // setWorkshopId(res.data.workshopId);
        saved = true;
        updateImage(res.data);
      })
      .catch((error) => {
        console.log(error);
        saved = false;
      });
    return saved;
  };

  const updateImage = (res) => {
    if (res.imageNumber === "IMAGE1") {
      setImage1Url(res.imageUrl);
    } else if (res.imageNumber === "IMAGE2") {
      setImage2Url(res.imageUrl);
    } else if (res.imageNumber === "IMAGE3") {
      setImage3Url(res.imageUrl);
    } else if (res.imageNumber === "IMAGE4") {
      setImage4Url(res.imageUrl);
    } else if (res.imageNumber === "IMAGE5") {
      setImage5Url(res.imageUrl);
    }
  };

  // Phone Number Validation
  const validatePhone = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    const limitedValue = value.slice(0, 10); // Limit to 10 digits
    setPhoneNumber(limitedValue);
    // Set validation state based on the new value
    setIsValidPhone(limitedValue.length === 10);
  };

  const isValidForm = () => {
    const trimmedName = name?.trim();
    const trimmedOwnerName = ownerName?.trim();
    
    // Only workshop name, owner name, and phone are mandatory
    const hasRequiredFields = trimmedName && trimmedOwnerName && phoneNumber.length === 10;
    
    return hasRequiredFields;
  };

  const onFailedSave = () => {
    setIsLoading(false);
    setIsSaved(false);
    setHasError(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const workshop = {
      workshopId,
      name,
      ownerName,
      phoneNumber,
      address,
    };

    const formIsValid = isValidForm();
    if (!formIsValid) {
      console.log("Form validation failed:", {
        name: name?.trim(),
        ownerName: ownerName?.trim(),
        phoneNumber: phoneNumber
      });
      onFailedSave();
      return;
    }

    api
      .put("/workshops", workshop)
      .then((res) => {
        navigate("/show-my-workshop");
      })
      .catch((error) => {
        onFailedSave();
      });
  };

  return isLoading ? (
    <div className={mainStyles.loading}>
      <img src={loadingImage} alt="loading" />
    </div>
  ) : (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <header className="text-3xl font-bold text-center text-gray-800 mb-8">
          Update Workshop
        </header>
        {workshop && (
          <div className="space-y-6">
            {/* Form Fields */}
            <div className="bg-white shadow-lg rounded-lg p-6 space-y-4">
              <TextField
                fullWidth
                variant="outlined"
                className="border-gray-300 rounded-md"
                onChange={(e) => setName(e.target.value)}
                label="Enter Workshop/Garage Name"
                defaultValue={workshop?.name}
              />
              <TextField
                fullWidth
                variant="outlined"
                className="border-gray-300 rounded-md"
                onChange={(e) => setOwnerName(e.target.value)}
                label="Enter Owner Name"
                defaultValue={workshop?.ownerName}
              />
              <TextField
                fullWidth
                variant="outlined"
                className="border-gray-300 rounded-md"
                type="tel"
                onChange={validatePhone}
                value={phoneNumber}
                inputProps={{ maxLength: 10 }}
                label="Enter Phone Number"
              />
              {!isValidPhone && phoneNumber.length > 0 && (
                <p className="text-red-500 text-sm">
                  Please enter a valid 10-digit Phone number
                </p>
              )}
              <TextField
                fullWidth
                variant="outlined"
                className="border-gray-300 rounded-md"
                multiline
                rows={4}
                onChange={(e) => setAddress(e.target.value)}
                label="Enter Address"
                defaultValue={workshop?.address}
              />
            </div>

            {/* Image Upload Sections */}
            {[1, 2, 3, 4, 5].map((num) => {
              const imageUrl = eval(`image${num}Url`);
              const imageUploaded = eval(`image${num}Uploaded`);
              const imageUploadFail = eval(`image${num}UploadFail`);
              const imageLoading = eval(`image${num}Loading`);
              
              const handleFileChange = (e, num) => {
                const file = e.target.files[0];
                if (file) {
                  eval(`setImage${num}(file)`);
                  eval(`setImage${num}Loading(true)`);
                  eval(`setImage${num}Uploaded(false)`);
                  eval(`setImage${num}UploadFail(false)`);
                  
                  // Automatically upload when file is selected
                  const formData = new FormData();
                  formData.append("file", file);
                  formData.append("imageNumber", `IMAGE${num}`);
                  if (workshopId) {
                    formData.append("workshopId", workshopId);
                  } else {
                    formData.append("workshopId", "");
                  }
                  
                  api
                    .post("/workshops/images", formData, {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                    })
                    .then((res) => {
                      eval(`setImage${num}Loading(false)`);
                      eval(`setImage${num}Uploaded(true)`);
                      eval(`setImage${num}UploadFail(false)`);
                      updateImage(res.data);
                    })
                    .catch((error) => {
                      console.log(error);
                      eval(`setImage${num}Loading(false)`);
                      eval(`setImage${num}Uploaded(false)`);
                      eval(`setImage${num}UploadFail(true)`);
                    });
                }
              };
              
              return (
                <div key={num} className="bg-white shadow-lg rounded-lg p-6">
                  <div className="text-lg text-center font-semibold text-gray-700 mb-4">
                    Image {num}
                  </div>
                  <div className="flex flex-col items-center gap-4">
                    {imageUrl && (
                      <div className="w-full max-w-md mb-4">
                        <img
                          src={imageUrl}
                          alt={`image${num}`}
                          className="w-full h-48 object-cover rounded-lg border-2 border-gray-200 shadow-md"
                        />
                      </div>
                    )}
                    
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      id={`fileInput${num}`}
                      onChange={(e) => handleFileChange(e, num)}
                      disabled={imageLoading}
                    />
                    
                    <label
                      htmlFor={`fileInput${num}`}
                      className={`w-full max-w-md py-3 px-6 font-semibold rounded-lg shadow-md transition flex items-center justify-center gap-2 ${
                        imageLoading
                          ? "bg-blue-400 text-white cursor-not-allowed"
                          : "bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 cursor-pointer"
                      }`}
                    >
                      {imageLoading ? (
                        <>
                          <CircularProgress size={20} thickness={4} sx={{ color: 'white' }} />
                          <span>Uploading...</span>
                        </>
                      ) : (
                        <>
                          <ImageIcon className="w-5 h-5" />
                          <span>{imageUrl ? "Change Image" : "Upload Image"}</span>
                        </>
                      )}
                    </label>

                    {imageUploaded && !imageLoading && (
                      <p className="text-green-600 font-medium">
                        Image uploaded successfully
                      </p>
                    )}
                    {imageUploadFail && !imageLoading && (
                      <p className="text-red-600 font-medium">Image upload failed</p>
                    )}
                  </div>
                </div>
              );
            })}

            {/* Save Button */}
            <div className="flex justify-center pt-4">
              <button
                onClick={handleSubmit}
                className="flex items-center gap-2 px-8 py-4 bg-blue-600 text-white font-semibold text-lg rounded-lg shadow-md hover:bg-blue-700 active:bg-blue-800 transition focus:ring-2 focus:ring-blue-400"
              >
                <SaveIcon className="w-6 h-6" />
                Save Workshop
              </button>
            </div>

            {/* Error and Success Messages */}
            <div className="text-center">
              {hasError && (
                <p className="text-red-600 font-medium text-lg">
                  Please enter all the mandatory fields with correct value
                </p>
              )}

              {isSaved && (
                <p className="text-green-600 font-medium text-lg">
                  Workshop Saved Successfully
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
